import React from 'react';
import { bool } from 'prop-types';
import { Icon } from 'semantic-ui-react';

const BoolIcon = ({ value = false }) => (
    <Icon
        size="large"
        name={value ? 'check circle' : 'remove circle'}
        color={value ? 'green' : 'red'}
    />
);

BoolIcon.propTypes = {
    value: bool,
};

export default BoolIcon;
